<app-parameter-card [title]="title" [icon]="icon" [hide]="hide">
  <mat-form-field>
  <input #textInput [placeholder]="parameterData.name"
         [value]="parameterData.value" matInput>
  </mat-form-field>
</app-parameter-card>
